import PropTypes from 'prop-types';
import FirebaseContext, { withFirebase } from './context';
import Firebase from './firebase';

const FirebasePropType = PropTypes.instanceOf(Firebase);

export default Firebase;

export { FirebaseContext, withFirebase, FirebasePropType };
